import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";

export const getUserMemo = (id, userToken) => {
  return axios.get(`/api/comments/profile/${id}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const useUserMemo = (id, userToken) => {
  return useQuery({
    queryKey: ["memoUser"],
    queryFn: () => getUserMemo(id, userToken),
    enabled: !!id,
  });
};

export const getProfileMemo = (id, userToken) => {
  return axios.get(`/api/comments/profile/${id}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const useProfileMemo = (id, userToken) => {
  return useQuery({
    queryKey: ["memoProfile"],
    queryFn: () => getProfileMemo(id, userToken),
    enabled: !!id,
  });
};

export const addNewMemo = (data) => {
  const memoData = data.data;
  return axios.post(`/api/comments/profile/${data.profileID}`, memoData, {
    headers: {
      Authorization: `Bearer ${data.token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const useAddNewMemo = () => {
  return useMutation(addNewMemo, {
    onSuccess: () => {
      console.log("success");
    },
    onError: (error) => {
      console.log({ error });
    },
  });
};
